import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

var _infoMapping;

import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types-create authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { BTreeMap, BTreeSet, Bytes, CodecSet, Compact, DoNotConstruct, Enum, HashMap, Int, Null, Option, Range, RangeInclusive, Result, Struct, Tuple, U8aFixed, UInt, Vec, VecFixed, WrapperKeepOpaque, WrapperOpaque } from '@polkadot/types-codec';
import { assert, isNumber, stringify } from '@polkadot/util';
import { TypeDefInfo } from "../types/index.js";
import { getTypeDef } from "../util/getTypeDef.js";

function getTypeDefType(_ref) {
  var lookupName = _ref.lookupName,
      type = _ref.type;
  return lookupName || type;
}

function getSubDefArray(value) {
  assert(value.sub && Array.isArray(value.sub), function () {
    return "Expected subtype as TypeDef[] in ".concat(stringify(value));
  });
  return value.sub;
}

function getSubDef(value) {
  assert(value.sub && !Array.isArray(value.sub), function () {
    return "Expected subtype as TypeDef in ".concat(stringify(value));
  });
  return value.sub;
}

function getSubType(value) {
  return getTypeDefType(getSubDef(value));
} // create a maps of type string CodecClasss from the input


function getTypeClassMap(value) {
  var subs = getSubDefArray(value);
  var map = {};

  for (var i = 0; i < subs.length; i++) {
    map[subs[i].name] = getTypeDefType(subs[i]);
  }

  return map;
} // create an array of type string CodecClasss from the input


function getTypeClassArray(value) {
  return getSubDefArray(value).map(getTypeDefType);
}

function createInt(Clazz, _ref2) {
  var displayName = _ref2.displayName,
      length = _ref2.length;
  assert(isNumber(length), function () {
    return "Expected bitLength information for ".concat(displayName || Clazz.constructor.name, "<bitLength>");
  });
  return Clazz.with(length, displayName);
}

function createHashMap(Clazz, value) {
  var _getTypeClassArray = getTypeClassArray(value),
      _getTypeClassArray2 = _slicedToArray(_getTypeClassArray, 2),
      keyType = _getTypeClassArray2[0],
      valueType = _getTypeClassArray2[1];

  return Clazz.with(keyType, valueType);
}

function createWithSub(Clazz, value) {
  return Clazz.with(getSubType(value));
}

var infoMapping = (_infoMapping = {}, _defineProperty(_infoMapping, TypeDefInfo.BTreeMap, function (registry, value) {
  return createHashMap(BTreeMap, value);
}), _defineProperty(_infoMapping, TypeDefInfo.BTreeSet, function (registry, value) {
  return createWithSub(BTreeSet, value);
}), _defineProperty(_infoMapping, TypeDefInfo.Compact, function (registry, value) {
  return createWithSub(Compact, value);
}), _defineProperty(_infoMapping, TypeDefInfo.DoNotConstruct, function (registry, value) {
  return DoNotConstruct.with(value.displayName || value.type);
}), _defineProperty(_infoMapping, TypeDefInfo.Enum, function (registry, value) {
  var subs = getSubDefArray(value);
  return Enum.with(subs.every(function (_ref3) {
    var type = _ref3.type;
    return type === 'Null';
  }) ? subs.reduce(function (out, _ref4, count) {
    var index = _ref4.index,
        name = _ref4.name;
    out[name] = index || count;
    return out;
  }, {}) : getTypeClassMap(value));
}), _defineProperty(_infoMapping, TypeDefInfo.HashMap, function (registry, value) {
  return createHashMap(HashMap, value);
}), _defineProperty(_infoMapping, TypeDefInfo.Int, function (registry, value) {
  return createInt(Int, value);
}), _defineProperty(_infoMapping, TypeDefInfo.Linkage, function (registry, value) {
  var type = "Option<".concat(getSubType(value), ">"); // eslint-disable-next-line sort-keys

  var Clazz = Struct.with({
    previous: type,
    next: type
  }); // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

  Clazz.prototype.toRawType = function () {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
    return "Linkage<".concat(this.next.toRawType(true), ">");
  };

  return Clazz;
}), _defineProperty(_infoMapping, TypeDefInfo.Null, function (registry, _) {
  return Null;
}), _defineProperty(_infoMapping, TypeDefInfo.Option, function (registry, value) {
  assert(value.sub && !Array.isArray(value.sub), 'Expected type information for Option'); // NOTE This is opt-in (unhandled), not by default
  // if (value.sub.type === 'bool') {
  //   return OptionBool;
  // }

  return createWithSub(Option, value);
}), _defineProperty(_infoMapping, TypeDefInfo.Plain, function (registry, value) {
  return registry.getOrUnknown(value.type);
}), _defineProperty(_infoMapping, TypeDefInfo.Range, function (registry, value) {
  return createWithSub(Range, value);
}), _defineProperty(_infoMapping, TypeDefInfo.RangeInclusive, function (registry, value) {
  return createWithSub(RangeInclusive, value);
}), _defineProperty(_infoMapping, TypeDefInfo.Result, function (registry, value) {
  var _getTypeClassArray3 = getTypeClassArray(value),
      _getTypeClassArray4 = _slicedToArray(_getTypeClassArray3, 2),
      Ok = _getTypeClassArray4[0],
      Err = _getTypeClassArray4[1]; // eslint-disable-next-line @typescript-eslint/no-use-before-define


  return Result.with({
    Err: Err,
    Ok: Ok
  });
}), _defineProperty(_infoMapping, TypeDefInfo.Set, function (registry, value) {
  return CodecSet.with(getSubDefArray(value).reduce(function (result, _ref5) {
    var index = _ref5.index,
        name = _ref5.name;
    result[name] = index;
    return result;
  }, {}), value.length);
}), _defineProperty(_infoMapping, TypeDefInfo.Si, function (registry, value) {
  return getTypeClass(registry, registry.lookup.getTypeDef(value.type));
}), _defineProperty(_infoMapping, TypeDefInfo.Struct, function (registry, value) {
  return Struct.with(getTypeClassMap(value), value.alias);
}), _defineProperty(_infoMapping, TypeDefInfo.Tuple, function (registry, value) {
  return Tuple.with(getTypeClassArray(value));
}), _defineProperty(_infoMapping, TypeDefInfo.UInt, function (registry, value) {
  return createInt(UInt, value);
}), _defineProperty(_infoMapping, TypeDefInfo.Vec, function (registry, _ref6) {
  var sub = _ref6.sub;
  assert(sub && !Array.isArray(sub), 'Expected type information for vector');
  return sub.type === 'u8' ? Bytes : Vec.with(getTypeDefType(sub));
}), _defineProperty(_infoMapping, TypeDefInfo.VecFixed, function (registry, _ref7) {
  var displayName = _ref7.displayName,
      length = _ref7.length,
      sub = _ref7.sub;
  assert(sub && isNumber(length) && !Array.isArray(sub), 'Expected length & type information for fixed vector');
  return sub.type === 'u8' ? U8aFixed.with(length * 8, displayName) : VecFixed.with(getTypeDefType(sub), length);
}), _defineProperty(_infoMapping, TypeDefInfo.WrapperKeepOpaque, function (registry, value) {
  return createWithSub(WrapperKeepOpaque, value);
}), _defineProperty(_infoMapping, TypeDefInfo.WrapperOpaque, function (registry, value) {
  return createWithSub(WrapperOpaque, value);
}), _infoMapping);
export function constructTypeClass(registry, typeDef) {
  try {
    var Type = infoMapping[typeDef.info](registry, typeDef);
    assert(Type, 'No class created'); // don't clobber any existing

    if (!Type.__fallbackType && typeDef.fallbackType) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore ...this is the only place we we actually assign this...
      Type.__fallbackType = typeDef.fallbackType;
    }

    return Type;
  } catch (error) {
    throw new Error("Unable to construct class from ".concat(stringify(typeDef), ": ").concat(error.message));
  }
} // Returns the type Class for construction

export function getTypeClass(registry, typeDef) {
  return registry.getUnsafe(typeDef.type, false, typeDef);
}
export function createClassUnsafe(registry, type) {
  return (// just retrieve via name, no creation via typeDef
    registry.getUnsafe(type) || // we don't have an existing type, create the class via typeDef
    getTypeClass(registry, registry.isLookupType(type) ? registry.lookup.getTypeDef(type) : getTypeDef(type))
  );
}